var exports = {
  "kL": "xa15a2ab7--a0c9a8--container",
  "MR": "xa15a2ab7--a0c9a8--sms-container",
  "lB": "xa15a2ab7--a0c9a8--span-columns",
  "nn": "xa15a2ab7--a0c9a8--buttons-wrap",
};

module.exports = exports;
